import { lazy } from "react";
import type { SolutionRoute } from "../routes";
import type { SolutionSettings } from "../settings";
import type { NavItem } from "../../nav";
import { Icon } from "../../ui";
import "./people.css";

const PeopleListPage = lazy(() => import("./people-list").then((m) => ({ default: m.PeopleListPage })));
const PersonPage = lazy(() => import("./person-page").then((m) => ({ default: m.PersonPage })));

/** People: every member in one list, and a page per person. */
export const routes: SolutionRoute[] = [
  { solution: "people", path: "people", element: <PeopleListPage /> },
  { solution: "people", path: "people/:id", element: <PersonPage /> },
];

/** People has no settings of its own. */
export const settings: SolutionSettings[] = [];

export const nav: NavItem = { to: "/people", label: "People", icon: Icon.people, solution: "people", need: "people.view" };
